import { render } from "./TheSafeEmail.vue?vue&type=template&id=7df85c24&scoped=true"
import script from "./TheSafeEmail.vue?vue&type=script&lang=js"
export * from "./TheSafeEmail.vue?vue&type=script&lang=js"

import "./TheSafeEmail.vue?vue&type=style&index=0&id=7df85c24&lang=scss&scoped=true"

import exportComponent from "/home/forge/binalogue.stage-preview.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7df85c24"]])

export default __exports__